import{useContext as r}from"react";import{GenericAuthContext as t}from"./GenericAuthProvider.js";var e=function(){return r(t)};export{e as default};
//# sourceMappingURL=useGenericAuth.js.map
